export default __webpack_public_path__ + "static/13-b7645e9e984822f024ff2c1d508da440.jpg";